(() => {
  const descriptions = {
    Prestige: 'Overmadrass med Talalay-lateks og fiberfylt quilting. Avtakbart, vaskbart stretchtrekk.',
    Premium: 'Overmadrass med kjerne av Talalay-lateks og fiberfylt quilting. Avtakbart, vaskbart stretchtrekk.',
    Luxury: 'Vendbar overmadrass med kjerne av Talalay-lateks, bomull på sommersiden og ull på vintersiden.'
  };
  function initialize(root) {
    if (root.dataset.detailsReady) return;
    root.dataset.detailsReady = 'true';
    const viewer = document.createElement('dialog');
    viewer.className = 'bedtime-detail-dialog';
    viewer.setAttribute('aria-label', 'Forstørret produktbilde');
    viewer.innerHTML = '<button type="button" aria-label="Lukk forstørret bilde">×</button><img alt="" width="1200" height="900"><p></p>';
    root.append(viewer);
    viewer.querySelector('button').addEventListener('click', () => viewer.close());
    viewer.addEventListener('click', event => { if (event.target === viewer) viewer.close(); });
    const enhance = () => {
      root.querySelectorAll('.hallso-topper-image,.hallso-fabric-swatch,.hallso-headboard-image,.hallso-fabric-swatch-button img,.hallso-fabric-dialog-grid img').forEach(img => {
        const card = img.closest('button');
        if (!card || card.parentElement.classList.contains('bedtime-detail-wrap')) return;
        const wrap = document.createElement('div');
        wrap.className = 'bedtime-detail-wrap';
        card.before(wrap);
        wrap.append(card);
        const zoom = document.createElement('button');
        zoom.type = 'button';
        zoom.className = 'bedtime-detail-zoom';
        zoom.setAttribute('aria-label', 'Forstørr bilde av ' + (img.alt || card.textContent.trim()));
        zoom.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';
        zoom.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          const title = img.alt || card.textContent.trim();
          const large = viewer.querySelector('img');
          large.src = (img.currentSrc || img.src).replace(/([?&])size=256\b/, '$1size=1200');
          large.alt = title;
          const kind = img.classList.contains('hallso-topper-image') ? Object.keys(descriptions).find(key => title.startsWith(key)) : null;
          viewer.querySelector('p').textContent = kind ? descriptions[kind] : title;
          viewer.showModal();
        });
        wrap.append(zoom);
      });
    };
    const observer = new MutationObserver(enhance);
    observer.observe(root, { childList: true, subtree: true });
    enhance();
  }
  document.querySelectorAll('[data-hallso-pilot]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hallso-pilot]').forEach(initialize));
})();
